
export default function(o, newPassword, done){

  var data = {
    type: 'reset',
    token: o.store('token'),
    newPassword: newPassword,
    email: o.store('email'),
    user: o.store('email'),
    date: new Date(),
  }

  $.ajax({
    url: '/auth',
    type: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    contentType: "application/json",
    data: JSON.stringify(data)
  })
  .done(function(result, textStatus, jqXHR) {
    if(result.error){
      done(result)
    } else {
      done(null,result);
    }
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    done({error: 'post failed'});
  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/resetPassword/resetPassword.js